import * as React from 'react';

import styles from './Blinker.module.styl';

export class Blinker extends React.Component<any, any> {
  public render() {
    const { title } = this.props;

    return (
      <div className={styles.wrapper}>
        <span className={styles.title}>{title}</span>
      </div>
    );
  }
}
